<template>
	<div>
		<template v-for="(content, i) in componentItem.content">

			<ForegroundAudio 
				v-if="content === componentItem.content['foreground-audio']" 
				:key="i" 
				:componentItemContent="componentItem.content" 
				:componentItemSampleContent="sampleContent['foreground-audio']" />
			
			<BackgroundImage 
				v-else-if="content === componentItem.content['background-image']" 
				:key="i" 
				:backgroundImage="componentItem.content[i]" 
				:forTemplate="componentItem.template" />
			
			<div
				v-else-if="content === componentItem.content['content-image']"
				class="form-group" 
				:key="i" 
			>
				<label>{{i}}</label>

				<ImageUploader 
					:key="i" :size="'audio-image'" 
					:forTemplate="componentItem.template" 
					:imageFieldKey="i" 
					:imageFieldObject="componentItem.content" />

			</div>

			<div 
				class="form-group"
				v-else-if="typeof content === 'string'"
				:key="i" 
			>
				<label>{{i}}</label>
				<input 
					type="text" 
					class="form-control" 
					:id="i" 
					v-model="componentItem.content[i]" />
			</div>

		</template>
	</div>
</template>

<script>

	import BackgroundImage from '../BackgroundImage';
	import ForegroundAudio from '../ForegroundAudio';
	import ImageUploader from '../ImageUploader.vue';

	export default {

		components: {
			BackgroundImage,
			ForegroundAudio,
			ImageUploader
		},		
		
		name: 'Audio',
		
		props: ['componentItem', 'index', 'sampleContent'],

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>